import React from 'react'
import styled from 'styled-components'
import ArrowIcon from 'src/Component/ArrowIcon'
import { Caption1, Caption, LargeTitle } from 'src/Styles/text-styles'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import useMediaQuery from 'src/Utils/useMediaQuery'
import { UPLOAD, DOWNLOAD, PING } from 'src/Common/Constant'
import { localize } from 'src/lib/localize'
import { theme } from 'src/Styles/theme'

const Container = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-right: 16px;
  padding-left: 16px;
`

const HoverContainer = styled.div`
  box-sizing: border-box;
  position: relative;
`

const ToolTipTextView = styled.a`
  display: block;
  width: 60px;
  height: 60px;
  text-align: center;
  position: absolute;
  cursor: pointer;
`

const SpeedText = styled(LargeTitle)`
  @media (max-width: 768px) {
    margin-top: 16px;
    font-weight: 500;
  }
  @media (min-width: 768px) {
    margin-top: 24px;
    font-weight: 500;
  }
`
const SpeedDescription = styled(Caption1)`
  color: ${theme.colors.lightTextColor};
  margin-top: 16px;
`
const SpeedType = styled(Caption)`
  margin-top: 16px;
  font-weight: 500;
`

interface SpeedDataProps {
  dataIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  outerRingColor: string
  innerRingColor: string
  speed: string
  speedDescription: string
  speedType: string
  toolTipId: string
  toolTipText: string
}

const SpeedData = ({
  dataIcon,
  outerRingColor,
  innerRingColor,
  speed,
  speedDescription,
  speedType,
  toolTipId,
  toolTipText,
}: SpeedDataProps) => {
  const isMobileView = useMediaQuery(['(max-width: 768px)'], [true], false)
  const getStringforSpeedType = (type: string) => {
    switch (type) {
      case UPLOAD:
        return localize('LABEL')('Upload')
      case DOWNLOAD:
        return localize('LABEL')('Download')
      case PING:
        return localize('LABEL')('Ping')
    }
  }
  return (
    <Container>
      {isMobileView ? (
        <ArrowIcon
          Icon={dataIcon}
          OuterRingColor={outerRingColor}
          InnerRingColor={innerRingColor}
        />
      ) : (
        <HoverContainer>
          <ToolTipTextView
            data-for={toolTipId}
            data-tip={toolTipText}
            data-iscapture="true"
            data-border="true"
            data-text-color="black"
            data-border-color="#c9c9c9"
          ></ToolTipTextView>
          <ReactTooltip id={toolTipId} place="top" variant="light" />
          <ArrowIcon
            Icon={dataIcon}
            OuterRingColor={outerRingColor}
            InnerRingColor={innerRingColor}
          />
        </HoverContainer>
      )}
      <SpeedText>{speed}</SpeedText>
      <SpeedDescription>{speedDescription}</SpeedDescription>
      <SpeedType>{getStringforSpeedType(speedType)}</SpeedType>
    </Container>
  )
}

export default SpeedData
